import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'newTenantEvents.title',
    defaultMessage: 'New Tenant Events',
  },
  needsAttention: {
    id: 'newTenantEvents.needsAttention',
    defaultMessage: 'Needs attention, will not be submitted to TRACS.',
  },
  bannerText: {
    id: 'newTenantEvents.bannerText',
    defaultMessage:
      'Certifications that are not completed, will not be sent to TRACS.',
  },
  unit: {
    id: 'newTenantEvents.unit',
    defaultMessage: 'Unit',
  },
  hudUnitNumber: {
    id: 'newTenantEvents.hudUnitNumber',
    defaultMessage: 'HUD Unit #',
  },
  hudUnitNumberTooltip: {
    id: 'newTenantEvents.hudUnitNumberTooltip',
    defaultMessage:
      'If the HUD Contract Unit # differs from Fortress, it will appear here (if entered) ' +
      'and be reflected on the voucher sent to TRACS. To add one, open the unit and enter ' +
      'the HUD Unit # in Unit Affordable Setup.',
  },
  bedsBaths: {
    id: 'newTenantEvents.bedsBaths',
    defaultMessage: 'Beds / Baths',
  },
  floorPlan: {
    id: 'newTenantEvents.floorPlan',
    defaultMessage: 'Floor Plan',
  },
  certificationType: {
    id: 'newTenantEvents.certificationType',
    defaultMessage: 'Certification Type',
  },
  certComplete: {
    id: 'newTenantEvents.certComplete',
    defaultMessage: 'Cert Complete',
  },
  recertificationDueDate: {
    id: 'newTenantEvents.recertificationDueDate',
    defaultMessage: 'Recert Due Date',
  },
  correction: {
    id: 'newTenantEvents.correction',
    defaultMessage: 'Correction',
  },
  headOfHousehold: {
    id: 'newTenantEvents.headOfHousehold',
    defaultMessage: 'Head of Household',
  },
  subsidyRent: {
    id: 'newTenantEvents.subsidyRent',
    defaultMessage: 'Assistance Amount',
  },
  effectiveDate: {
    id: 'newTenantEvents.effectiveDate',
    defaultMessage: 'Effective Date',
  },
  tracsStatus: {
    id: 'newTenantEvents.tracsStatus',
    defaultMessage: 'Status',
  },
  tracsTooltip: {
    id: 'newTenantEvents.tracsStatusTooltip',
    defaultMessage:
      'Shows Incomplete until the certification is completed, then the TRACS submission status.',
  },
  tracsMessage: {
    id: 'newTenantEvents.tracsMessage',
    defaultMessage: 'TRACS Message',
  },
  actions: {
    id: 'newTenantEvents.actions',
    defaultMessage: 'Actions',
  },
  download50059: {
    id: 'newTenantEvents.download50059',
    defaultMessage: 'Download 50059',
  },
  download50059a: {
    id: 'newTenantEvents.download50059a',
    defaultMessage: 'Download 50059a',
  },
  downloadCertificationDisabledTooltip: {
    id: 'newTenantEvents.downloadCertificationDisabledTooltip',
    defaultMessage: 'Certification must be complete to perform this action.',
  },
  moveToNextVoucher: {
    id: 'newTenantEvents.moveToNextVoucher',
    defaultMessage: 'Move to Next Voucher',
  },
  moveToNextVoucherDisabledTooltip: {
    id: 'newTenantEvents.moveToNextVoucherDisabledTooltip',
    defaultMessage:
      'This event was already submitted. If something needs to be changed, reopen the cert',
  },
  confirmLabel: {
    id: 'newTenantEvents.confirmLabel',
    defaultMessage:
      'By selecting this box, I confirm all eligible unsubmitted Tenant Events will be sent to TRACS.',
  },
  modalTitle: {
    id: 'newTenantEvents.modalTitle',
    defaultMessage: 'Send / Receive Files',
  },
  modalDescription: {
    id: 'newTenantEvents.modalDescription',
    defaultMessage:
      'Please enter your iMAX WASS ID and Password to send and receive TRACS files.',
  },
  modalButtonText: {
    id: 'newTenantEvents.modalButtonText',
    defaultMessage: 'Submit Tenant Events to TRACS',
  },
  modalButtonTooltipAllEventsSubmitted: {
    id: 'newTenantEvents.modalButtonTooltipAllEventsSubmitted',
    defaultMessage: 'All eligible tenant events have already been submitted.',
  },
  modalButtonTooltipNoEvents: {
    id: 'newTenantEvents.modalButtonTooltipNoEvents',
    defaultMessage: 'No eligible New Tenant Events.',
  },
  sendReceive: {
    id: 'newTenantEvents.sendReceive',
    defaultMessage: 'Send / Receive',
  },
  bannerMessage: {
    id: 'newTenantEvents.bannerMessage',
    defaultMessage:
      'Only completed certifications will be sent to TRACS. ' +
      'To remove an event from this voucher, select Move to Next Voucher or ' +
      'update the Anticipated Voucher Date in the certification. ' +
      'If an event is missing, update its Anticipated Voucher Date to include it.',
  },
});
